import ComponentName from '@Constant/componentName'

const root = [
  {
    path: '/',
    redirect: {
      name: ComponentName.login
    }
  },
  {
    path: '/404',
    name: ComponentName.nofound,
    component: () => import('../views/extra/Nofound.vue')
  }
]

export default root
